import { css } from 'styled-components';
export default {
    aptos: {
        light: css `
      font-family: 'Aptos', sans-serif;
      font-style: normal;
      font-weight: 300;
    `,
        lightItalic: css `
      font-family: 'Aptos', sans-serif;
      font-weight: 300;
      font-style: italic;
    `,
        regular: css `
      font-family: 'Aptos', sans-serif;
      font-style: normal;
      font-weight: 400;
    `,
        regularItalic: css `
      font-family: 'Aptos', sans-serif;
      font-weight: 400;
      font-style: italic;
    `,
        semiBold: css `
      font-family: 'Aptos', sans-serif;
      font-style: normal;
      font-weight: 600;
    `,
        bold: css `
      font-family: 'Aptos', sans-serif;
      font-style: normal;
      font-weight: 700;
    `,
        extraBold: css `
      font-family: 'Aptos', sans-serif;
      font-style: normal;
      font-weight: 800;
    `,
        extraBoldItalic: css `
      font-family: 'Aptos', sans-serif;
      font-weight: 800;
      font-style: italic;
    `,
        black: css `
      font-family: 'Aptos', sans-serif;
      font-style: normal;
      font-weight: 900;
    `,
        blackItalic: css `
      font-family: 'Aptos', sans-serif;
      font-weight: 900;
      font-style: italic;
    `,
    },
    berlin: {
        bold: css `
      font-family: 'Berlin Sans FB Demi', sans-serif;
      font-style: normal;
      font-weight: 700;
    `,
    },
};
